import { IDENTIFIERS_REQUEST, IDENTIFIERS_SUCCESS, IDENTIFIERS_FAILURE } from 'app/actions/identifiers';
import {
  IDENTIFIER_MODIFY_REQUEST,
  IDENTIFIER_MODIFY_SUCCESS,
  IDENTIFIER_MODIFY_FAILURE,
} from 'app/actions/identifiers/block';

const defaultState = {
  loading: false,
  modifieId: null,
  result: null,
  identifiers: {},
};

const identifiers = (state = defaultState, action) => {
  switch (action.type) {
    case IDENTIFIERS_REQUEST: {
      return { ...state, loading: true };
    }

    case IDENTIFIERS_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }

    case IDENTIFIERS_FAILURE: {
      return { ...state, loading: false };
    }

    case IDENTIFIER_MODIFY_REQUEST: {
      return { ...state, modifieId: action.payload };
    }

    case IDENTIFIER_MODIFY_SUCCESS: {
      return { ...state, identifiers: { ...state.identifiers, ...action.payload }, modifieId: null };
    }

    case IDENTIFIER_MODIFY_FAILURE: {
      return { ...state, modifieId: action.payload };
    }

    default:
  }
  return state;
};

export default identifiers;
